<script setup lang="ts">
// @ts-expect-error raison: lib externe mal typée
import { defineProps, inject } from 'vue';
import { formatAmount } from '@/utils/formatters';

const BACKEND_URL = inject('BACKEND_URL');
const props = defineProps({
    produit: { type: Object, required: true },
    layout: { type: String, default: 'none' },
});
</script>
<template>
    <div class="card-product zoom">
        <div class="img-area">
            <div class="tag-set justify-content-end">
                <div class="tag2">-20%</div>
                <!-- <div class="tag-promo">Promo !</div> -->
            </div>
            <div class="btn-set">
                <button class="btn-ultra lg btn-panier"><!-- loading-->
                    <div class="btn-show">
                        <img src="/public/icons/icon-panier.svg" class="btn-icon" alt="" />
                    </div>
                    <div class="btn-loading">
                        <div class="loader-dots"></div>
                    </div>
                </button>
            </div>
            <router-link :to="(layout == 'frontoffice' ? '/front/market/produits/' : '/market/produits/') + props.produit.id" style="height: 290px;display: flex;justify-content: center;align-items: center;padding: 20px;">
                <img :src="BACKEND_URL + '/assets/market_produits/300/' + props.produit.image" class="img" style="max-width: 80%; max-height: 100%;" />
            </router-link>
        </div>
        <router-link :to="(layout == 'frontoffice' ? '/front/market/produits/' : '/market/produits/') + props.produit.id">
            <div class="text-area">
                <!-- <h6 class="subtitle">Accessoire Xbox</h6> -->
                <h5 class="title secondary-font">{{ props.produit.nom }}</h5>
                <h3 class="price secondary-font">{{ formatAmount(props.produit.montant) }} <span class="secondary-font">F</span></h3>
            </div>
        </router-link>
    </div>
</template>